import axios from "axios";

import { BUBA_API_AUTH_URL, getEnvironmentVariable } from "../utils/environment";
import { addStatusCodeInterceptorToInstance } from "../utils/loggers";

const getBubaClientAuth = () => {
  const bubaClientAuth = axios.create({
    baseURL: getEnvironmentVariable(BUBA_API_AUTH_URL),
    headers: { "Content-Type": "application/vnd.api+json" }
  });

  addStatusCodeInterceptorToInstance(bubaClientAuth);

  return bubaClientAuth;
};

export const bubaClientAuth = getBubaClientAuth();
